// extracted by mini-css-extract-plugin
export default {"icon":"style-module--icon--c+xrp","title":"style-module--title--+AoYN"};